import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/slack-notification-channel/constants';
import { slackNotificationChannelQueryKeys } from '@/modules/slack-notification-channel/queries/queryKeys';
import type { SetSlackNotificationChannelBody } from '@/modules/slack-notification-channel/types';
import { invalidateQuery } from '@/utils/queries';

/**
 * Sets the tenant notification channel. The API joins the channel first when it
 * is public and the bot is not yet a member.
 */
export const useSetSlackNotificationChannelMutation = () => {
  return useMutation({
    mutationFn: async (body: SetSlackNotificationChannelBody) => {
      const { data } = await fetchClient.PUT(endpoints.notificationChannel, {
        body,
      });
      return data;
    },
    onSettled: invalidateQuery(slackNotificationChannelQueryKeys.current()),
  });
};
